// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';

$w.onReady(function () {
	//TODO: write your page related code here...
});

export function generateVoucherWithGreetingButton_click(event) {
// Create voucher ID
    let voucherID = Math.random()*25131232513;
    voucherID = Math.floor(voucherID);

// Create voucher expiration date - today + 90 days
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + 90);
    let voucherExpirationDate = dateNow;

// Activate voucher
    let voucherStatus = true;

// Input data from text boxes saved in array 
    let toSave = {
      "Customer Name": $w('#voucherToInput').value,
      "Voucher From": $w('#voucherFromInput').value,
      "Package Description": $w('#packageDescriptionInput').value,
      "Spa Service Price": $w('#voucherServicePriceInput').value,
      "Spa Compound Price": $w('#voucherSpaCompoundPriceInput').value,
      "Greeting": $w('#greetingsInput').value,
      "Voucher ID": voucherID.toString(),
      "Expiration Date": voucherExpirationDate,
      "Voucher Status": voucherStatus    };

//Save input data to DB
    wixData.save("Vouchers", toSave);
}